/**
 * Display configuration for product attribute fields.
 *
 * This file is NOT auto-generated — it provides field grouping and display
 * hints that supplement the auto-generated product-schema.json.
 */

import { resolveColorHex, ENUM_ICONS } from "@/components/debug/enrichment-display-config";
import type { FieldGroup, SchemaDisplayConfig } from "@/components/debug/SchemaRenderer";

export const PRODUCT_FIELD_GROUPS: FieldGroup[] = [
  { label: "Identity", fields: ["name", "id", "catalog", "url", "gtin"] },
  { label: "Pricing", fields: ["current_price", "original_price", "offers"] },
  { label: "Brand", fields: ["brand", "brand_name", "brand_slug"] },
  {
    label: "Appearance",
    fields: ["color_info", "sizes", "materials", "fit", "dimensions", "patterns"],
  },
  { label: "Categories", fields: ["categories", "breadcrumbList"] },
  { label: "Media", fields: ["image", "images", "videos", "three_d_model"] },
  { label: "Details", fields: ["description", "extra_text", "additional_attributes", "tags"] },
  { label: "Ratings & Reviews", fields: ["rating", "review"] },
  { label: "Fulfillment", fields: ["fulfillment_info", "promotions"] },
];

export const PRODUCT_DISPLAY_CONFIG: SchemaDisplayConfig = {
  enumIcons: ENUM_ICONS,
  colorFields: new Set(["color_info"]),
  resolveColorHex,
};
